import messagingSocketSlice from 'components/ReusableComponents/MessagingSocket/MessagingSocketSlice'
import { connectRouter } from 'connected-react-router'
import pmsSyncStatusSlice from 'features/Welcome/HotelSwitcher/pmsSyncStatusSlice'
import { followUpSlice } from 'hooks/useMessageFollowUp'
import { combineReducers } from 'redux'

import emailLogsSlice from '../features/EmailLogs/EmailLogsSlice'
import signInSlice from '../features/Login/LoginSlice'
import manageUserDialogSlice from '../features/ManageUserDialog/ManageUserDialogSlice'
import versionCheckerSlice from '../hooks/versionChecker/versionCheckerSlice'
import arrivals from './arrivals'
import autoInvite from './autoInvite'
import billing from './billing'
import blacklist from './blacklist'
import campaigns from './campaigns'
import chatBotTraining from './chatBotTraining'
import device from './device'
import directMessaging from './directMessaging'
import header from './header'
import billings from './healthCheck/billings'
import invites from './healthCheck/invites'
import hcInvoices from './healthCheck/invoices'
import sync from './healthCheck/sync'
import hotelDetails from './hotelDetails'
import hotelsAndGroups from './hotelsAndGroups'
import insights from './insights'
import invoices from './invoices'
import login from './login'
import notifications from './notifications'
import reviewMessaging from './reviewMessaging'
import reviews from './reviews'
import salesMessaging from './salesMessaging'
import serviceMessaging from './serviceMessaging'
import socket from './socket'
import userPermissions from './userPermissions'

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    login,
    signIn: signInSlice.reducer,
    userPermissions,
    autoInvite,
    reviews,
    invoices,
    hotelsAndGroups,
    header,
    campaigns,
    blacklist,
    device,
    hotelDetails,
    serviceMessaging,
    salesMessaging,
    reviewMessaging,
    directMessaging,
    arrivals,
    socket,
    insights,
    chatBotTraining,
    notifications,
    billing,
    versionInfo: versionCheckerSlice.reducer,
    pmsSyncStatus: pmsSyncStatusSlice.reducer,
    emailLogs: emailLogsSlice.reducer,
    manageUsers: manageUserDialogSlice.reducer,
    healthCheck: combineReducers({
      invites,
      sync,
      billings,
      invoices: hcInvoices
    }),
    messagingSocket: messagingSocketSlice.reducer,
    followUps: followUpSlice.reducer
  })

export default rootReducer
